import { Box, Text } from "@mantine/core";
import { IconBan, IconCheck, IconChecks } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

type UserMessageProps = {
  message?: string | null;
  time?: string | null;
  isRead: boolean;
  attachments?: React.ReactNode;
  isEdited?: boolean;
  isDeleted?: boolean;
};

const UserMessage = ({
  message,
  time,
  isRead,
  attachments,
  isEdited,
  isDeleted,
}: UserMessageProps) => {
  const { t } = useTranslation("messages");
  return (
    <Box className="flex justify-end">
      <Box
        bg={"var(--color-blue-bubble)"}
        className="px-[7px] m-2 text-white max-w-[85%] min-w-[20%] rounded-tr-none rounded-tl-[7px] rounded-bl-[7px] rounded-br-[7px] wrap-break-word whitespace-pre-wrap"
      >
        {!isDeleted && attachments}
        {isDeleted ? (
          <Box className="flex items-center gap-1">
            <IconBan size={20} color="var(--color-gray-medium)" />
            <Text fz={"md"} c="var(--color-gray-medium)">
              {t("youDeletedMessage")}
            </Text>
          </Box>
        ) : (
          <Text fz={"md"} c="black">
            {message}
          </Text>
        )}
        {time ? (
          <Box className="flex items-center justify-end gap-1 h-2.5 pb-1">
            {isEdited && !isDeleted && (
              <Text fz={12} c={"var(--color-gray)"}>
                {t("edited")}
              </Text>
            )}
            <Text fz={12} c={"var(--color-gray)"}>
              {time}
            </Text>
            {!isDeleted &&
              (isRead ? (
                <IconChecks height={16} width={16} color="var(--color-blue)" />
              ) : (
                <IconCheck height={16} width={16} color="var(--color-gray)" />
              ))}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default UserMessage;
